export const getEStoreCatalogList = state => {
    return state.list
}

export const getEStoreCatalogDataProps = state => {
    return state.props
}

export const getEStoreCatalogRequestList = state => {
    return state.request_list
}


// WEBPACK FOOTER //
// ./src/store/modules/eStoreCatalog/getters.js